import { mergeStyles } from "@fluentui/merge-styles";
import { FONT_SIZE_REGULAR } from "../../config/fontSizes";

export const wrapperClass = mergeStyles({
  fontSize: FONT_SIZE_REGULAR,
 height: "100vh",
width: "100%",
boxSizing: "border-box",
overflow: "hidden",
});
